import CreateButton from "../components/CreateButton"
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import api from "../api";
import { ReactComponent as CopyIcon } from "../assets/images/icons/ic-copy.svg";
import { ReactComponent as DeleteIcon } from "../assets/images/icons/ic-delete.svg";
import Badge from "../components/Badge";
import Card from "../components/cards/Card";
import HeaderFooterLayout from '../components/layouts/HeaderFooterLayout';
import MeatBallsMenu from "../components/MeatBallsMenu";
import Table from "../components/Table";
import typo from '../typography.module.css';
import styles from './Articles.module.css';
import AlertDialog from "../components/dialogs/AlertDialog";

const Articles = () => {

  const { t } = useTranslation();
  const navigate = useNavigate();
  const [articles, setArticles] = useState([]);
  const [loading, setLoading] = useState(false)
  const [alert, setAlert] = useState({ open: false, title: '', text: '' })

  useEffect(() => {

    const getArticles = async () => {
      setLoading(true);
      try {
        const articles = await api.get('/admin/articles');
        setArticles(articles);
      } catch (error) {
        console.error(error);
      }
      setLoading(false)
    }

    getArticles();

  }, []);

  const deleteArticle = async (articleId) => {
    try {
      await api.delete(`/admin/articles/${articleId}`);
      setArticles((prev) => prev.filter((w) => w.id !== articleId));
    } catch (error) {
      console.error(error);
    }
  }

  const duplicateArticle = async (articleId) => {
    try {
      const duplicated = await api.post(`/admin/articles/${articleId}/duplicate`);
      setArticles((prev) => [...prev, duplicated]);
    } catch (error) {
      console.error(error);
    }
  }

  const getStatusColor = (status) => {
    switch (status) {
      case 'public':
        return 'var(--sf-green)'
      case 'draft':
        return 'var(--secondary)'
      case 'hidden':
        return 'var(--sf-red)'
      default:
        return 'var(--sf-grey)'
    }
  }

  const getArticleActions = (article) => {
    if (!article) return []
    const actions = [
      {
        label: "Duplica",
        icon: CopyIcon,
        onClick: () => {
          setAlert({
            open: true,
            title: `Duplicare ${article.name}?`,
            text: '',
            actions: [
              {
                label: 'Conferma',
                onClick: async () => {
                  await duplicateArticle(article.id)
                  setAlert((prev) => {
                    prev.open = false
                    return { ...prev }
                  })
                }
              }
            ]
          })
        }
      }
    ]
    if (article.status === 'draft') {
      actions.push(
        {
          label: "Elimina",
          icon: DeleteIcon,
          onClick: () => {
            setAlert({
              open: true,
              title: `Eliminare ${article.name}?`,
              text: 'L\'operazione non potrà essere annullata',
              actions: [
                {
                  label: 'ELIMINA',
                  onClick: async () => {
                    await deleteArticle(article.id)
                    setAlert((prev) => {
                      prev.open = false
                      return { ...prev }
                    })
                  },
                  color: 'var(--sf-red)'
                }
              ]
            })
          },
          color: 'var(--sf-red)'
        }
      )
    }
    return actions
  }

  return (
    <HeaderFooterLayout>
      <div className={styles.container}>
        <div className={styles.section}>
          <div className={styles.sectionInner}>
            <div className={styles.header}>
              <div className={typo.title}>Article</div>
              <CreateButton style={{ padding: '0.5rem 1rem' }} onClick={() => { navigate('/articles/create/editor') }}>
                Aggiungi

              </CreateButton>
            </div>
            <Card noPadding>
              <Table
                style={{ borderRadius: 0 }}
                loading={loading}
                columns={[
                  {
                    key: 'id',
                    label: 'ID',
                    type: 'number',
                    pinned: false
                  },
                  {
                    key: 'thumbnail',
                    label: 'COPERTINA',
                    type: 'image',
                    pinned: false
                  },
                  {
                    key: 'name',
                    label: 'NOME',
                    type: 'string',
                    pinned: false
                  },
                  {
                    key: 'description',
                    label: 'DESCRIZIONE',
                    type: 'custom',
                    pinned: false
                  },
                  {
                    key: 'status',
                    label: 'STATO',
                    type: 'custom',
                    pinned: false
                  },
                  {
                    key: 'actions',
                    label: 'AZIONI',
                    type: 'custom',
                    pinned: false
                  }
                ]}
                elements={
                  articles.map(w => ({
                    id: w.id,
                    name: w.name,
                    description: { value: w.description, type: 'string', component: <div className={styles.description}>{w.description}</div> },
                    thumbnail: <img src={w.thumbnail} alt="" className={styles.thumbnail} />,
                    status: { value: w.status, type: 'string', component: <Badge name={`${t(`status.${w.status}`)}`} color={getStatusColor(w.status)} /> },
                    actions: <MeatBallsMenu style={{ padding: '0.5rem' }} actions={getArticleActions(w)} />,
                    href: `/articles/${w.id}/editor`
                  })).sort((a, b) => a.name.localeCompare(b.name))}
                defaultSort={{ key: 'name', direction: 'asc' }}
              />
            </Card>
          </div>
        </div>
      </div>
      <AlertDialog open={alert.open} title={alert.title} text={alert.text} actions={alert.actions} onClose={() => {
        setAlert((prev) => {
          prev.open = false
          return { ...prev }
        })
      }} />
    </HeaderFooterLayout >
  )

}

export default Articles;
